<template>
    <div ref="case">
        <!--banner -->
        <div v-if="isShow">
            <img style="height: 450px;width:100%;" src="../../assets/02-productCenter/01-serveCustomers.jpg" alt="">
            <div style="padding: 50px 200px;">
                <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
                <div style="margin-right: 40px;" class="color-243">ABOUT</div>
                <div class="color-243">PRODUCTS</div>
                </div>
                <div style="margin-bottom: 20px;font-size: 24px;" class="color-97">相关产品</div>
                <el-carousel indicator-position="none" :interval="4000" trigger="click" type="card" height="400px">
                    <el-carousel-item>
                        <img style="height: 92%;" src="../../assets/02-productCenter/02-caseService.png" alt="">
                        <div style="position: absolute;bottom: 8px;left: 44%;">案件生态服务</div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <img style="height: 90%;" src="../../assets/02-productCenter/03-eFile.png" alt="">
                        <div style="position: absolute;bottom: 8px;left: 46%;">电子卷宗</div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <img style="height: 92%;" src="../../assets/02-productCenter/04-ci.png" alt="">
                        <div style="position: absolute;bottom: 8px;left: 46%;">集中调证</div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <img style="height: 400px;width:100%;" src="../../assets/02-productCenter/05-moreUsers.jpg" alt="">
            <div style="padding: 50px 200px;">
                <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
                <div style="margin-right: 40px;" class="color-243">ABOUT</div>
                <div class="color-243">PRODUCTS</div>
                </div>
                <div style="margin-bottom: 20px;font-size: 24px;" class="color-97">相关产品</div>
                <el-carousel indicator-position="none" :interval="4000" trigger="click" type="card" height="400px">
                    <el-carousel-item>
                        <img style="height: 92%;" src="../../assets/02-productCenter/06-assetsM.png" alt="">
                        <div style="position: absolute;bottom: 0px;left: 41%;display:flex;"><el-link style="font-size: 16px;" type="primary" @click="handleSwitchPage('资产管理系统')">资产管理系统</el-link></div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <img style="height: 90%;" src="../../assets/02-productCenter/07-tzzM.png" alt="">
                        <div style="position: absolute;bottom: 0px;left: 40%;display:flex;"><el-link style="font-size: 16px;" type="primary" @click="handleSwitchPage('投资者关系管理系统')">投资者关系管理系统</el-link></div>
                    </el-carousel-item>
                    <el-carousel-item>
                        <img style="height: 92%;" src="../../assets/02-productCenter/08-cgM.png" alt="">
                        <div style="position: absolute;bottom: 0px;left: 40%;display:flex;"><el-link style="font-size: 16px;" type="primary" @click="handleSwitchPage('采购管理系统')">采购管理系统</el-link></div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <img style="height: 400px;width:100%;" src="../../assets/02-productCenter/09-gdwz.png" alt="">
            <div style="padding: 50px 200px;">
                <div style="display: flex; width: 100%; justify-content: center;margin-bottom: 10px;font-size: 24px;">
                <div style="margin-right: 40px;" class="color-243">ABOUT</div>
                <div class="color-243">PRODUCTS</div>
                </div>
                <div style="margin-bottom: 30px;font-size: 24px;color:#000;">国产力量————您的专属服务器解决方案</div>
                <div style="margin-bottom: 50px;font-size: 24px;text-align: left;text-indent: 2em;" class="color-97">我司全新拓展业务领域，现正式代理广电五洲国产服务器销售。我们致力于为您提供性能卓越、品牌可靠的国产服务器，以满足您在数据处理、存储和计算等方面的多样化需求。凭借专业团队和优质服务，为您的业务发展提供坚实的技术支撑。</div>
                <div style="display: flex;align-items: center;margin-bottom: 24px;">
                    <div style="font-size: 20px;width: 20px;margin-right: 100px;">鲲鹏服务器</div>
                    <img style="height: 100%;" src="../../assets/02-productCenter/10-wzcc.png" alt="">
                    <div style="width: 100%;font-size: 50px;font-weight: bold;cursor: pointer;" @click="handleTo">......</div>
                </div>
                <div style="display: flex;align-items: center;">
                    <div style="font-size: 20px;width: 20px;margin-right: 124px;">更多代理产品</div>
                    <div style="text-align:left;" class="color-97">
                        <div style="margin-bottom:8px;">国产信创系列：鲲鹏存储服务器、飞腾服务器、国产X86服务器、桌面终端</div>
                        <div style="margin-bottom:8px;">通用计算产品：单路通用服务器、双路通用服务器、四路/八路服务器、高密度服务器</div>
                        <div style="margin-bottom:8px;">智能计算产品：CPU服务器、昇腾服务器、昇腾AI卡、昇腾智能边缘产品</div>
                        <div style="margin-bottom:8px;">存储产品：集中式存储、分布式存储、超融合、数据保护</div>
                        <div>应用产品：网络安全、云计算、视频监控、边缘计算、工作站</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 采购页面 -->
        <div v-else-if="isShowPurchase">
            <img style="height: 450px;width:100%;margin-bottom: 50px;" src="../../assets/02-productCenter-cgM/01-banner.jpg" alt="">
            <div style="display: flex;margin-left: 100px;margin-bottom: 50px;" class="color-97">
                <div style="margin-right: 5px;cursor: pointer;" @click="isShow = true;isShowPurchase = false;">资产中心</div>
                <div style="margin-right: 5px;">></div>
                <div>采购管理系统</div>
            </div>
            <div style="font-size: 24px; margin-bottom: 100px;" class="color-97">采购管理系统</div>
            <div style="font-size: 24px;" class="color-113-188">供应商管理机制及流程</div>
            <img style="height: 600px;margin-bottom: 50px;" src="../../assets/02-productCenter-cgM/02.png" alt="">
            <div style="font-size: 24px;" class="color-113-188">全流程闭环采购，在线立项-招采-签约</div>
            <img style="width: 66%; margin-bottom: 120px;" src="../../assets/02-productCenter-cgM/03.jpg" alt="">
            <div style="font-size: 24px; margin-bottom: 50px;" class="color-113-188">多角色门户，适配所有工作场景</div>
            <div style="display: flex;justify-content: space-between;padding: 0px 100px 50px;">
                <div>
                   <img style="height: 300px;width:100%;margin-bottom: 30px;" src="../../assets/02-productCenter-cgM/04.jpg" alt="">
                   <div class="color-92-64-56">领导门户</div>
                </div>
                <div>
                   <img style="height: 300px;width:100%;margin-bottom: 30px;" src="../../assets/02-productCenter-cgM/05.jpg" alt="">
                   <div class="color-92-64-56">业务管理员门户</div>
                </div>
                <div>
                   <img style="height: 300px;width:100%;margin-bottom: 30px;" src="../../assets/02-productCenter-cgM/06.jpg" alt="">
                   <div class="color-92-64-56">供应商门户</div>
                </div>
            </div>
        </div>
        <!-- 投资者页面 -->
        <div v-else-if="isShowInvestor">
            <img style="height: 450px;width:100%;margin-bottom: 50px;" src="../../assets/02-productCenter-tzzM/01-banner.jpg" alt="">
            <div style="display: flex;margin-left: 100px;margin-bottom: 50px;" class="color-97">
                <div style="margin-right: 5px;cursor: pointer;" @click="isShow = true;isShowInvestor = false;">资产中心</div>
                <div style="margin-right: 5px;">></div>
                <div>投资者关系管理</div>
            </div>
            <div style="font-size: 24px; margin-bottom: 30px;" class="color-97">投资者关系管理（IRM）</div>
            <div style="font-size: 18px;text-indent: 3em; margin-bottom: 60px; padding: 0px 400px;color:#000;">目前市面上针对IRM的数字化解决方案大多都集中在对外业务部分，丰富与投资者对话的途径和信息披露的方式，拉近上市公司与投资人之间的距离。但对于企业内部IRM工作的开展并和管理却未能提供抓手，缺少有效的工具去解决预算和资源之间的限制与矛盾。</div>
            <img style="height: 600px;margin-bottom: 50px;" src="../../assets/02-productCenter-tzzM/02.jpg" alt="">
            <img style="height: 600px;margin-bottom: 50px;" src="../../assets/02-productCenter-tzzM/03.jpg" alt="">
        </div>
        <!-- 资产管理系统页面 -->
        <div v-else-if="isShowAssets">
            <img style="height: 450px;width:100%;margin-bottom: 50px;" src="../../assets/02-productCenter-assetsM/01-banner.jpg" alt="">
            <div style="display: flex;margin-left: 100px;margin-bottom: 50px;" class="color-97">
                <div style="margin-right: 5px;cursor: pointer;" @click="isShow = true;isShowAssets = false;">资产中心</div>
                <div style="margin-right: 5px;">></div>
                <div>资产管理系统</div>
            </div>
            <div style="font-size: 24px;" class="color-97">资产管理系统</div>
            <div style="padding: 50px 290px;">
                <div style="padding: 25px 0;display: flex;">
                    <div style="margin-right: 30px;">
                        <img style="height: 300px;width: 400px;" src="../../assets/02-productCenter-assetsM/02.jpg" alt="">
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 40px 0;">
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">科学管理、灵活应用</div>
                            <div class="color-97">覆盖全类型资产档案模板，快速完成资产登记，一资一档一码构建真实、准确、及时的资产数字化底座。</div>
                        </div>
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">底数清、情况明</div>
                            <div class="color-97">确保集团上下一本帐，支持“千人千面”自助输出台账报表;</div>
                            <div class="color-97">海量资产一键盘清出账，灵活支撑业务决策。</div>
                        </div>
                    </div>
                </div>
                <div style="padding: 50px 0;display: flex;">
                    <div style="margin-right: 30px;">
                        <img style="height: 300px;width: 400px;" src="../../assets/02-productCenter-assetsM/03.jpg" alt="">
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 40px 0;">
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">资产卡片</div>
                            <div class="color-97">资产沉淀数据分类整理，形成资产卡片信息，协助用户快速掌握资产的全生命周期。</div>
                        </div>
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">全流程闭环管理</div>
                            <div class="color-97">资产工作行为全流程记录，资产卡片涵盖:基本信息、用途规划、变更记录、使用记录、评估记录、经营项目、处置项目、租金收入、资产附件等全方位信息档案。</div>
                        </div>
                    </div>
                </div>
                <div style="padding: 50px 0;display: flex;">
                    <div style="margin-right: 30px;">
                        <img style="height: 300px;width: 400px;" src="../../assets/02-productCenter-assetsM/04.jpg" alt="">
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 40px 0;">
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">资产评估</div>
                            <div class="color-97">实现资产评估信息的公开共享、规范透明;</div>
                            <div class="color-97">工作全流程记录，信息留痕，快速溯源。</div>
                        </div>
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">工作监督</div>
                            <div class="color-97">通过对评估流程各节点的用时统计，快速定位工作中的“瓶颈环节”，协助用户快读定位问题，并进行精准的干预和纠偏，实现资产评估工作的效能跃升。</div>
                        </div>
                    </div>
                </div>
                <div style="padding: 50px 0;display: flex;">
                    <div style="margin-right: 30px;">
                        <img style="height: 300px;width: 400px;" src="../../assets/02-productCenter-assetsM/05.jpg" alt="">
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 40px 0;">
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">资产地图</div>
                            <div class="color-97">可视化资产地图，能够实现[省-市-区] 三级穿透，逐级看清资产产权与经营布局，从宏观到微观清晰掌握全局资产动态,</div>
                        </div>
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">经营规划</div>
                            <div class="color-97">构建“租售一体化”中台，实现业务在线联动，充分提升资产经营利用效率;</div>
                            <div class="color-97">租金缴纳、租约续期等周期性工作的前置提醒，减少不必要的损失与风险。</div>
                        </div>
                    </div>
                </div>
                <div style="padding: 50px 0;display: flex;">
                    <div style="margin-right: 30px;">
                        <img style="height: 300px;width: 400px;" src="../../assets/02-productCenter-assetsM/06.jpg" alt="">
                    </div>
                    <div style="display: flex; flex-direction: column; justify-content: space-between;text-align: left;padding: 40px 0;">
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">数据上报</div>
                            <div class="color-97">支持“在线填报+自动收集”闭环模式，让子公司经营数据快速上报、归集。</div>
                        </div>
                        <div>
                            <div style="margin-bottom: 20px; font-size: 18px;" class="color-113-188">辅助决策</div>
                            <div class="color-97">各级资产数据形成一屏看板，轻松掌握全局经营进展，辅助高效决策。</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import {WOW} from 'wowjs'
import foot from '../../components/foot'
export default {
    data(){
        return{
            isShow: true,
            // 采购
            isShowPurchase: false,
            // 资产
            isShowAssets: false,
            // 投资者
            isShowInvestor: false
        }
    },
    components:{
        foot
    },
    methods:{
        handleSwitchPage (page) {
            if (page === '资产管理系统') {
                this.isShow = false
                this.isShowAssets = true
                window.scrollTo(0, 0);
            } else if (page === '投资者关系管理系统') {
                this.isShow = false
                this.isShowInvestor = true
                window.scrollTo(0, 0);
            } else if (page === '采购管理系统') {
                this.isShow = false
                this.isShowPurchase = true
                window.scrollTo(0, 0);
            }
        },
        handleTo () {
            window.open("https://www.wuzhoucloud.com/pt/AI.html")
        }
    },
    mounted(){
        //  new WOW().init()
    }
}
</script>
<style lang="less" scoped>
.color-243 {
    color: rgb(243, 243, 243);
}

.color-97 {
    color: rgb(97, 97, 97);
}

.color-113-188 {
    color: rgb(0, 113, 188);
}

.color-92-64-56 {
    color: rgb(92, 64, 56);
}
</style>


// WEBPACK FOOTER //
// src/views/anli/case.vue